import React from 'react';
import { Modal, Platform } from 'react-native';

export default function WebModal({ visible, children, animationType = 'slide' }) {
  if (Platform.OS === 'web') {
    if (!visible) return null;
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        boxSizing: 'border-box',
        overflowY: 'auto',
      }}>
        {children}
      </div>
    );
  }

  return (
    <Modal visible={visible} transparent animationType={animationType}>
      {children}
    </Modal>
  );
}